import { post, serialize } from '../httpClient';

export const stripeServerAPI = {
  calculateTax: body => post('/api/stripe/calculate-tax', serialize(body)),
  createTaxTransaction: body => post('/api/stripe/create-tax-transaction', serialize(body)),
};
